import PropTypes from 'prop-types'

// react-day-picker handles locale natively; no provider needed.
export const AdasLocalizationProvider = ({ children }) => <>{children}</>

AdasLocalizationProvider.propTypes = { children: PropTypes.node, adapterLocale: PropTypes.string }
